import { client } from './client';
import { appConfig } from '../config/app-config';

function getReceipt(mpoNum: string) {
  return client(
    `receipt/${mpoNum}`,
    {
      method: 'GET',
    },
    appConfig.apiUrls.micro,
    true
  );
}

export { getReceipt };
